import React, { useState, useEffect } from "react";

import CheckIcon from "@material-ui/icons/Check";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import useModal from "../hooks/modals";

const ConfirmButton = ({
  refreshKey,
  label,
  children,
  action,
  variant = "contained",
  color = "primary",
  fullWidth,
  showContentAfterAction,
  validation,
  disabled,
}) => {
  const [isOpen, handleClick, handleClose] = useModal();
  const [afterAction, setAfterAction] = useState(false);

  useEffect(() => {
    setAfterAction(false);
    handleClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  return (
    <React.Fragment>
      <Button
        {...{ variant, color, fullWidth, disabled }}
        onClick={handleClick}
      >
        {label}
      </Button>
      <Dialog open={isOpen}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          {afterAction && !showContentAfterAction ? (
            <CheckIcon style={{ fill: "green" }} />
          ) : (
            children
          )}
        </DialogContent>
        <DialogActions>
          {afterAction ? (
            <Button variant="contained" color="primary" onClick={handleClose}>
              Ok
            </Button>
          ) : (
            <React.Fragment>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (validation === undefined || validation) {
                    action();
                    setAfterAction(true);
                  }
                }}
              >
                Confirm
              </Button>
              <Button style={{ float: "left" }} onClick={handleClose}>
                Cancel Action
              </Button>
            </React.Fragment>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ConfirmButton;
